import {
	Colors,
	BadgeStatus,
	TransactionStatus,
	SubscriptionStatus,
	PaymentStatus,
	BusinessPartnerProfileStatus,
	CommunityPartnerProfileStatus,
	PartnershipRequestStatus,
	CreditStatus,
	TransactionReason,
	JobStatus
} from 'Types';

const dropdown_all = 'dropdown.all';

/**
 * Merges an array of BadgeStatus objects into a single array, combining objects with the same value.
 * @param array - The array of BadgeStatus objects to merge.
 * @returns The merged array of BadgeStatus objects.
 */

const mergeBadgeStatuses = (array: BadgeStatus[]) => {
	const map = new Map();
	for (const item of array) {
		const value = item.value;
		const existingItem = map.get(value);
		if (existingItem) {
			Object.assign(existingItem, item);
		} else {
			map.set(value, { ...item });
		}
	}
	return Array.from(map.values());
};

export const businessPartnerStatus: BadgeStatus[] = [
	{
		value: BusinessPartnerProfileStatus.Registration,
		label: 'badge.registration',
		color: Colors.warning
	},
	{
		value: BusinessPartnerProfileStatus.NoSubscription,
		label: 'badge.no-subscription',
		color: Colors.muted
	},
	{
		value: BusinessPartnerProfileStatus.Active,
		label: 'badge.active',
		color: Colors.primary
	},
	{
		value: BusinessPartnerProfileStatus.Expired,
		label: 'badge.expired',
		color: Colors.red
	}
];
export const PartnershipRequestStatusList: BadgeStatus[] = [
	{
		value: PartnershipRequestStatus.PendingApproval,
		label: 'badge.pending-approval',
		color: Colors.warning
	},
	{
		value: PartnershipRequestStatus.Approved,
		label: 'badge.approved',
		color: Colors.green
	},
	{
		value: PartnershipRequestStatus.Rejected,
		label: 'badge.rejected',
		color: Colors.red
	},
	{
		value: PartnershipRequestStatus.AutoRejected,
		label: 'badge.rejected',
		color: Colors.red
	}
];
export const communityPartnerStatus: BadgeStatus[] = [
	{
		value: CommunityPartnerProfileStatus.Registration,
		label: 'badge.registration',
		color: Colors.warning
	},
	{
		value: CommunityPartnerProfileStatus.Active,
		label: 'badge.active',
		color: Colors.primary
	},
	{
		value: CommunityPartnerProfileStatus.PendingApproval,
		label: 'badge.pending-approval',
		color: Colors.warning
	},
	{
		value: CommunityPartnerProfileStatus.Rejected,
		label: 'badge.rejected',
		color: Colors.red
	}
];

export const companyPaymentStatus: BadgeStatus[] = [
	{
		value: '',
		label: 'badge.active',
		title: 'active',
		color: Colors.primary
	},
	{
		value: PaymentStatus.Pending,
		label: 'badge.pending',
		title: 'pending',
		color: Colors.warning
	},
	{
		value: PaymentStatus.Failed,
		label: 'badge.failed',
		title: 'failed',
		color: Colors.red
	},
	{
		value: PaymentStatus.InProcess,
		label: 'badge.processing',
		title: 'processing',
		color: Colors.warning
	},
	{
		value: PaymentStatus.Paid,
		label: 'badge.paid',
		title: 'paid',
		color: Colors.primary
	},
	{
		value: PaymentStatus.PendingSepa,
		label: 'badge.pending-sepa',
		title: 'pendingSepa',
		color: Colors.warning
	},
	{
		value: PaymentStatus.Rejected,
		label: 'badge.rejected',
		title: 'rejected',
		color: Colors.red
	}
];

export const paymentStatus: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: TransactionStatus.Pending,
		label: 'badge.pending',
		title: 'pending',
		color: Colors.warning
	},
	{
		value: TransactionStatus.Paid,
		label: 'badge.paid',
		title: 'paid',
		color: Colors.success
	}
];

export const invoiceStatus: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: TransactionStatus.Paid,
		label: 'badge.paid',
		title: 'Paid',
		color: Colors.success
	},
	{
		value: TransactionStatus.Pending,
		label: 'badge.unpaid',
		title: 'Pending',
		color: Colors.muted
	},
	{
		value: TransactionStatus.Failed,
		label: 'badge.failed',
		title: 'Failed',
		color: Colors.red
	},
	{
		value: TransactionStatus.InProcess,
		label: 'dropdown.in-process',
		title: 'InProcess',
		color: Colors.warning
	},
	{
		value: TransactionStatus.Canceled,
		label: 'badge.canceled',
		title: 'Canceled',
		color: Colors.red
	},
	{
		value: TransactionStatus.Rejected,
		label: 'badge.rejected',
		title: 'Rejected',
		color: Colors.red
	},
	{
		value: TransactionStatus.PendingSepa,
		label: 'badge.pending-sepa',
		title: 'PendingSepa',
		color: Colors.warning
	}
];

export const invoiceReason: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: TransactionReason.NewSubscription,
		label: 'label.new-subscription',
		title: 'NewSubscription',
		color: Colors.muted
	},
	{
		value: TransactionReason.RenewSubscription,
		label: 'label.renew-subscription',
		title: 'RenewSubscription',
		color: Colors.warning
	},
	{
		value: TransactionReason.UpgradeSubscription,
		label: 'label.upgrade-subscription',
		title: 'UpgradeSubscription',
		color: Colors.primary
	}
];

export const creditStatus: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: CreditStatus.Paid,
		label: 'dropdown.paid',
		title: 'paid',
		color: Colors.primary
	},
	{
		value: CreditStatus.Pending,
		label: 'dropdown.pending',
		title: 'pending',
		color: Colors.warning
	}
	// {
	// 	value: CreditStatus.InProcess,
	// 	label: 'dropdown.in-process',
	// 	title: 'inProcess',
	// 	color: Colors.warning
	// },
	// {
	// 	value: CreditStatus.Canceled,
	// 	label: 'dropdown.canceled',
	// 	title: 'canceled',
	// 	color: Colors.red
	// },
	// {
	// 	value: CreditStatus.Failed,
	// 	label: 'dropdown.failed',
	// 	title: 'Failed',
	// 	color: Colors.red
	// }
];

export const companySettlementStatus = mergeBadgeStatuses([
	...invoiceStatus,
	...companyPaymentStatus
]);

export const jobStatus: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: JobStatus.Draft,
		label: 'dropdown.draft',
		title: 'draft',
		color: Colors.yellow
	},
	{
		value: JobStatus.Published,
		label: 'dropdown.published',
		title: 'published',
		color: Colors.success
	},
	{
		value: JobStatus.Unpublished,
		label: 'dropdown.unPublished',
		title: 'unPublished',
		color: Colors.muted
	},
	{
		value: JobStatus.Expired,
		label: 'dropdown.expired',
		title: 'expired',
		color: Colors.muted
	}
];

export const jobStatusWithoutDraft: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: JobStatus.Published,
		label: 'dropdown.published',
		title: 'published',
		color: Colors.success
	},
	{
		value: JobStatus.Unpublished,
		label: 'dropdown.unPublished',
		title: 'unPublished',
		color: Colors.muted
	},
	{
		value: JobStatus.Expired,
		label: 'dropdown.expired',
		title: 'expired',
		color: Colors.muted
	}
];

export const subStatus: BadgeStatus[] = [
	{
		value: SubscriptionStatus.active,
		label: 'dropdown.active',
		title: 'active',
		color: Colors.primary
	},
	{
		value: SubscriptionStatus.pendingApproval,
		label: 'dropdown.pending-approval',
		title: 'pending-approval',
		color: Colors.warning
	},
	{
		value: SubscriptionStatus.pendingPayment,
		label: 'dropdown.pending-payment',
		title: 'pending-payment',
		color: Colors.warning
	},
	{
		value: SubscriptionStatus.rejected,
		label: 'dropdown.manually-rejected',
		title: 'manually-rejected',
		color: Colors.red
	},
	{
		value: SubscriptionStatus.expired,
		label: 'badge.expired',
		title: 'manually-Expired',
		color: Colors.red
	}
];

export const requestStatus: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: '0',
		label: 'dropdown.pending',
		title: 'pending',
		color: Colors.warning
	},
	{
		value: '1',
		label: 'dropdown.canceled-by-user',
		title: 'canceled',
		color: Colors.muted
	},
	{
		value: '2',
		label: 'dropdown.approved',
		title: 'approved',
		color: Colors.success
	},
	{
		value: '3',
		label: 'dropdown.rejected',
		title: 'rejected',
		color: Colors.error
	}
];

export const eventStatus: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: '0',
		label: 'dropdown.draft',
		title: 'draft',
		color: Colors.yellow
	},
	{
		value: '1',
		label: 'dropdown.published',
		title: 'published',
		color: Colors.success
	},
	{
		value: '2',
		label: 'dropdown.canceled',
		title: 'canceled',
		color: Colors.error
	},
	{
		value: '99',
		label: 'dropdown.finished',
		title: 'finished',
		color: Colors.muted
	}
];

export const agentPartnerApprovalStatus: BadgeStatus[] = [
	{
		value: SubscriptionStatus.active,
		label: 'dropdown.active',
		title: 'active',
		color: Colors.primary
	},
	{
		value: SubscriptionStatus.pendingApproval,
		label: 'dropdown.pending-approval',
		title: 'pending-approval',
		color: Colors.warning
	},
	{
		value: SubscriptionStatus.pendingPayment,
		label: 'dropdown.pending-payment',
		title: 'pending-payment',
		color: Colors.warning
	},
	{
		value: SubscriptionStatus.rejected,
		label: 'dropdown.manually-rejected',
		title: 'manually-rejected',
		color: Colors.red
	},
	{
		value: SubscriptionStatus.expired,
		label: 'badge.expired',
		title: 'manually-Expired',
		color: Colors.red
	}
];

export const CommunityPartnerCreditStatus: BadgeStatus[] = [
	{
		value: CreditStatus.Paid,
		label: 'dropdown.paid',
		title: 'paid',
		color: Colors.primary
	},
	{
		value: CreditStatus.Pending,
		label: 'dropdown.pending',
		title: 'pending',
		color: Colors.warning
	},
	{
		value: CreditStatus.InProcess,
		label: 'dropdown.in-process',
		title: 'inProcess',
		color: Colors.warning
	},
	{
		value: CreditStatus.Canceled,
		label: 'dropdown.canceled',
		title: 'canceled',
		color: Colors.red
	},
	{
		value: CreditStatus.Failed,
		label: 'dropdown.failed',
		title: 'Failed',
		color: Colors.red
	}
];

export const subscriptionStatusFilter: BadgeStatus[] = [
	{
		value: '',
		label: dropdown_all,
		title: 'all',
		color: Colors.primary
	},
	{
		value: SubscriptionStatus.active,
		label: 'dropdown.active',
		title: 'active',
		color: Colors.primary
	},
	{
		value: SubscriptionStatus.expired,
		label: 'dropdown.expired',
		title: 'expired',
		color: Colors.primary
	}
];
